import React, { createContext, useContext, useEffect, useState, useRef } from 'react';
import { supabase } from './supabase';

const ThemeContext = createContext({ theme: 'light', changeTheme: () => {} });

export function ThemeProvider({ user, children }) {
  const [theme, setTheme] = useState('light');
  const loadedUserRef = useRef(null);

  useEffect(() => {
    async function fetchTheme() {
      if (!user?.id) return;
      if (loadedUserRef.current === user.id) return;

      const { data } = await supabase.from('profiles').select('theme').eq('id', user.id).single();
      if (data?.theme) setTheme(data.theme);
      loadedUserRef.current = user.id;
    }
    fetchTheme();
  }, [user?.id]);

  // Application classe dark sur <html>
  useEffect(() => {
    if (theme === 'dark') {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [theme]);

  const changeTheme = async (newTheme) => {
    setTheme(newTheme);
    if (user?.id) {
      await supabase
        .from('profiles')
        .upsert({ id: user.id, theme: newTheme }, { onConflict: 'id' });
    }
  };

  return <ThemeContext.Provider value={{ theme, changeTheme }}>{children}</ThemeContext.Provider>;
}

export function useTheme() {
  return useContext(ThemeContext);
}
